import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import ECommerceDirectorApp from "./ecommerce/director/ECommerceDirectorApp";
import ECommerceTeamApp from "./ecommerce/team/ECommerceTeamApp";
import ECPApp from "./ecp/ECPApp";
import PMDiamondsApp from "./pmdiamonds/PMDiamondsApp";
import Footer from './common/Footer';

const ENV = !process.env.NODE_ENV || process.env.NODE_ENV === "development" ? "development" : "production";

const Routes = () => {
    return (
        <Router basename="/eizba">
            <Switch>
                <Route path="/e-commerce-director">
                    <ECommerceDirectorApp />
                </Route>
                <Route path="/e-commerce-team">
                    <ECommerceTeamApp />
                </Route>
                <Route path="/ecp">
                    <ECPApp />
                </Route>
                <Route path="/pm-diamonds">
                    <PMDiamondsApp />
                </Route>
                <Route path="/">
                    <Nav />
                </Route>
            </Switch>
        </Router>
    );
};

export default Routes;

const Nav = () => {
    return (
        <div>
        <nav>
            <ul>
                <li>
                    <Link to="/e-commerce-director">e-Commerce Director</Link>
                </li>
                <li>
                    <Link to="/e-commerce-team">e-Commerce Team</Link>
                </li>
                <li>
                    <Link to="/ecp">ECP</Link>
                </li>
                <li>
                    <Link to="/pm-diamonds">PM Diamonds</Link>
                </li>
            </ul>
        </nav>
        <Footer />
        </div>
    );
};
